/**
 * AttendanceSummary widget — top-of-dashboard KPI strip.
 *
 * Now a thin wrapper over the shared <OrgAttendanceKpis> component
 * (variant="compact"). The KPI tiles, the live `/v1/attendance/overview`
 * fetch, the `present_today` field map, and the i18n labels all live in
 * that one shared component so this widget and the Attendance Overview
 * page can no longer drift apart (they used to: this widget read
 * `present_today`, the overview page read `present` and silently
 * rendered 0).
 *
 * See src/components/attendance/OrgAttendanceKpis.tsx.
 */

import React from 'react';
import OrgAttendanceKpis from '../../../../components/attendance/OrgAttendanceKpis';

const AttendanceSummary: React.FC = () => <OrgAttendanceKpis variant="compact" />;

export default AttendanceSummary;
